import 'hacktimer'
// 引入项目配置
import { AppFactory } from '@/plugins/appFactory'
// 引入路由配置
import router from '@/options/router'
// 引入公共css
import '@/assets/css/common.css'
// 通讯实例（兼容老代码）
import { eventHub } from '@/plugins/eventHub'
// 引入请求地址列表（兼容老代码）
import URL from '@/options/url'
import TaskUrl from '@/options/taskUrl'
import DoclibUrl from '@/options/doclibUrl'
// 引入公共函数库（兼容老代码）
import library from '@/plugins/library'
// 初始化诸葛埋点方法
import zhuge from '@/plugins/zhuge'
// 引入service实例（兼容老代码）
import service from '@/options/service'
// 表格滚动
import ElTableInfiniteScroll from '@/plugins/directive/tableInfiniteScroll/el-table-infinite-scroll.js'
// 消息
import message from '@/plugins/TipMessage'

// 引入初始化组件
import App from '@/App.vue'
// 初始化APM
try {
  if (window.MAIAAPM && window.MAIAAPM.init) {
    window.MAIAAPM.init({
      key: process.env.VUE_APP_APM_KEY
    })
  }
} catch (error) {
  console.warn('MAIA_APM_INIT_ERROR:', error)
}
// 创建app
const app = AppFactory(App)
app.config.globalProperties.$Bus = eventHub
app.config.globalProperties.URL = URL
app.config.globalProperties.TaskUrl = TaskUrl
app.config.globalProperties.DoclibUrl = DoclibUrl
app.config.globalProperties.library = library
app.config.globalProperties.zhuge = zhuge
app.config.globalProperties.service = service
// 全局提示
app.config.globalProperties.$cusMessage = message
app.use(router).mount('#app')

app.directive('el-table-infinite-scroll', ElTableInfiniteScroll)
